import { _SET_EXPERIMENTS_DATA } from "./mutations"

export const SET_EXPERIMENTS_DATA = "setExperimentsData"

export default {
  [SET_EXPERIMENTS_DATA]({ commit }, experimentsData: Map<string, any>) {
    commit(_SET_EXPERIMENTS_DATA, experimentsData)
  }
}
